import { render, staticRenderFns } from "./CollectListSearchResultLayout.vue?vue&type=template&id=e1f4b998&scoped=true"
import script from "./CollectListSearchResultLayout.vue?vue&type=script&lang=js"
export * from "./CollectListSearchResultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f4b998",
  null
  
)

export default component.exports